export const CardRange = () => {
  return (
    <svg viewBox="0 0 148 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_571_2379)">
        <rect
          x="66.396"
          width="59.9772"
          height="27.8855"
          rx="4.72939"
          fill="#03292E"
        />
        <rect
          x="76.7241"
          y="11.0508"
          width="39.3211"
          height="5.78429"
          rx="2.89214"
          fill="white"
          fillOpacity="0.9"
        />
        <path
          d="M97.3846 33.9799C96.8325 34.5319 95.9374 34.5319 95.3853 33.9799L89.2908 27.8854L103.479 27.8854L97.3846 33.9799Z"
          fill="#03292E"
        />
        <circle
          cx="8.48715"
          cy="8.48715"
          r="8.48715"
          transform="matrix(-1 0 0 1 104.869 40.1406)"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_571_2379"
          x1="0"
          y1="0"
          x2="375.239"
          y2="3.36383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_571_2379">
          <rect width="148" height="57" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
